import { useAppSelector } from "store/store.hooks";

export const useCustodyAccountsSelector = () => useAppSelector(state => state.custodyAccountsReducer);
